export function sortOrderByPrice(order) {
  return {
    'ledger.balance.totalAmount': {
      order: order.up ? 'asc' : 'desc',
      missing: 0,
    },
  };
}

export function sortString(order, name) {
  return {
    [name]: {
      order: order.up ? 'asc' : 'desc',
      missing: order.up ? '_first' : '_last',
    },
  };
}
